import React, { useState, useCallback, useContext, useEffect, useRef } from 'react';
import { TimerContext } from '../context/TimerContext';
import "react-tabs/style/react-tabs.css"; 
import '../styles/GameAndClosing.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; 
import { logoMap } from './PendingTicket';

const GamesAndClosing = () => {
  const [index, setIndex] = useState(0);
  const {
    selectedDay,
    selectDay,
    dropdownVisible,
    toggleDropdown,
    fetchGameData,
  } = useContext(TimerContext);
  const [refreshing, setRefreshing] = useState(false);
  const modalRef = useRef();

  const routes = [
    { key: "NLA", title: "NLA GAMES" },
    { key: "OTHER", title: "OTHER GAMES" },
  ];

  const handleRefresh = async () => {
    setRefreshing(true);
    await fetchGameData();
    setRefreshing(false);
  };

  const renderDropdownItem = useCallback(
    (item, gameType) => {
      // Determine logo: use Huntex logo only if game name contains "HUNTEX"
      const gameLogo = item.d.toUpperCase().includes("HUNTEX")
        ? logoMap["HUNTEX LOTTO"]
        : (logoMap[item.d] || logoMap["NATIONAL WEEKLY"]);
      
      return (
        <div
          onClick={() => selectDay(item, "game1", "game2")}
          className="dropdown-item"
        >
          <div className="dropdown-item-header">
            <img
              className="dropdown-item-logo"
              src={gameLogo}
              alt={`${item.d} logo`}
            />
            <p className="dropdown-item-text">{item.d}</p>
          </div>
          <p className="dropdown-item-text">Game Date: {item.nextGameDate}</p>
          <p className="dropdown-item-text">Closing Time: {item.closingTime}</p>
        </div>
      );
    },
    [selectDay]
  );

  const renderScene = (route) => {
    const data = route.key === "NLA" ? selectedDay.game1 : selectedDay.game2;

    return (
      <div>
        {data.map((item, index) =>
          renderDropdownItem(item, route.key.toLowerCase())
        )}
      </div>
    );
  };

  // Close modal when clicking outside
  useEffect(() => {
    if (!dropdownVisible) return;
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        toggleDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownVisible, toggleDropdown]);

  const selectedGameName = selectedDay.d || selectedDay.sortedGames?.[0]?.d || "";
  const selectedLogo = selectedGameName.toUpperCase().includes("HUNTEX")
    ? logoMap["HUNTEX LOTTO"]
    : (logoMap[selectedGameName] || logoMap["NATIONAL WEEKLY"]);
  
  // Determine which category the selected game belongs to
  const isNLAGame = selectedDay.game1?.some(g => g.d === selectedGameName);
  const gameCategory = isNLAGame ? "NLA" : "OTHER";

  return (
    <div>
      <button className="dropdown-button" onClick={toggleDropdown}>
        <img
          className="dropdown-button-logo"
          src={selectedLogo}
          alt={`${selectedGameName} logo`}
        />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ fontSize: "12px", fontWeight: "600", color: "#fff", background: isNLAGame ? "#0a324d" : "#0a324d", padding: "2px 8px", borderRadius: "4px" }}>
              {gameCategory} GAMES
            </span>
            <span style={{ color: "#0a324d", fontSize: "14px", fontWeight: "BOLD" }}>{selectedGameName}</span>
          </div>
          <span style={{ fontSize: "11px", color: "#666", marginTop: "2px" }}>
            Tap to switch between NLA & Other Games
          </span>
        </div>
        <i style={{  color: "#0a324d", fontSize: "16px" }} className={`fas fa-chevron-${dropdownVisible ? 'up' : 'down'}`}></i>
      </button>
      {dropdownVisible && (
        <div className="modal-container" ref={modalRef}>
          <div className="tab-bar">
            {routes.map((route, idx) => (
              <button
                key={route.key}
                className={`tab-bar-button ${index === idx ? "active-tab" : ""}`}
                onClick={() => setIndex(idx)}
              >
                {route.title}
                 <i 
                    className={`fas fa-chevron-right ${index === idx ? "arrow-active" : "arrow-inactive"}`} 
                    style={{ marginLeft: "8px", fontSize: "12px" }}
                  ></i>
              </button>
            ))}
          </div>
          {renderScene(routes[index])}
        </div>
      )}
    </div>
  );
};

export default GamesAndClosing;
